import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
const QUANTITY_WIDTH = 105;

export const columns = [
    {
        dataField: 'ProductCode',
        caption: 'Product',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1
    },
    {
        dataField: 'Quantity',
        caption: 'Quantity',
        width: QUANTITY_WIDTH,
        format: '#0.00',
    },
    {
        dataField: 'Price',
        caption: 'Price',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        format: '#0.00',
    },
    {
        dataField: 'QuantityAvailable',
        caption: 'Available',
        width: QUANTITY_WIDTH,
        format: '#0.00',
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.xl0,
    },
    {
        dataField: 'DetailedDescription',
        caption: 'Extended description',
        minWidth: COLUMN_SIZE.xl0,
    },
    {
        dataField: 'Comment',
        caption: 'Comment',
        minWidth: COLUMN_SIZE.xl0,
    }
];
